(function() {
    const imageSliders = document.querySelectorAll('.jsImageSlider');

    for (let i = 0; i < imageSliders.length; i++) {
        const slideCount = imageSliders[i].querySelectorAll('img').length;
        if (slideCount > 1) {
            imageSliders[i].classList.add('first');

            new Flickity(imageSliders[i], {
                prevNextButtons: true,
                pageDots: true,
                on: {
                    change: index => {
                        imageSliders[i].classList.remove('first');
                        imageSliders[i].classList.remove('last');

                        if (index === 0) imageSliders[i].classList.add('first');
                        else if (index === (slideCount - 1)) imageSliders[i].classList.add('last');
                    }
                }
            });
        }
    }
})();
